import React, { useEffect, useState } from "react";
import Modal from "react-bootstrap/Modal";
import { Card, Button, Row, Col, Form } from "react-bootstrap";
import { Link, useNavigate } from "react-router-dom";
import { useSelector, useDispatch } from "react-redux";
import {
  fetchRestaurantList,
  destroyItems,
  resetConfirmSubscription,
  resetRestaurantDetailsNow,
  fetchRestaurantDetails,
} from "../actions/restaurantActions";
import Loader from "../components/Loader";
import Messages from "../components/Messages";
import RestaurantsHeader from "../components/RestaurantsHeader";
import styled from "styled-components";
import { logout } from "../actions/userActions";
import { CopyToClipboard } from "react-copy-to-clipboard";
import { FiCopy } from "react-icons/fi";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { ToastContainer } from "react-toastify";
import { fetchReservationDeactivate } from "../actions/reservationsActions";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faArrowRightToBracket,
  faUtensils,
  faPen,
  faTrash,
} from "@fortawesome/free-solid-svg-icons";
import {
  CalendarSvgIcon,
  FilterSvgIcon,
  GearSvgIcon,
  NoPhoneSvgIcon,
  OnOffSvgIcon,
  PhoneSvgIcon,
  PlusSvgIcon,
  ReservationSvgIcon,
  TableSvgIcon,
  UsersSvgIcon,
  XSvgIcon,
  UserSvgIcon,
  ClockSvgIcon,
  BellSvgIcon,
  BubbleTextSvgIcon,
  ZoneSvgIcon,
  PennotebookSvgIcon,
  ExtrasSvgIcon,
} from "../icons/SvgIcons";
import { ConfirmationModal } from "../components/ConfirmationModal";
import { ModernButton } from "../components/DefaultImports";

const Container = styled.div`
  max-width: 1200px;
  height: 100%;
  margin: 0 auto;
  padding: 30px;
  padding-top: 60px;

  @media (max-width: 768px) {
    padding: 0px;
    padding-top: 0;
    margin: 0;
  }
`;

const StyledCard = styled.div`
  position: relative;
  display: flex;
  overflow: hidden;
  padding: 0;
  height: 150px;
  width: 100%;
  flex-wrap: wrap;
  border: 1px solid #c9cdd4;
  margin-bottom: 5px;
  border-radius: 5px;

  @media (max-width: 576px) {
    height: auto;
    min-height: 125px;
  }
`;

const StyledCardTop = styled.div`
  width: 100%;
  background-color: #99b0ad;
  height: 35px;
  color: white;
  font-size: 1.1rem;
  padding: 0 10px;
  border-radius: 4px;

  display: flex;
  align-items: center;
  justify-content: space-between;

  @media (max-width: 576px) {
    font-size: 0.95rem;
    height: 32px;
    padding: 0 8px;
  }
`;

const StyledCardBot = styled.div`
  margin: 8px;
  padding: 5px;
  height: auto;
  width: 100%;

  @media (max-width: 576px) {
    margin: 5px;
    padding: 4px;
  }
`;

const ActionButtons = styled.div`
  display: flex;
  gap: 10px;
  justify-content: flex-end;
  width: 100%;

  @media (max-width: 576px) {
    gap: 3px;
    justify-content: space-between;
    flex-wrap: nowrap;
  }
`;

const ButtonsCol = styled(Col)`
  @media (max-width: 576px) {
    margin-top: 8px;
    padding-left: 4px;
    padding-right: 4px;
  }
`;

const CompactModernButton = styled(ModernButton)`
  white-space: nowrap;

  @media (max-width: 576px) {
    height: 28px;
    min-height: 28px;
    padding: 0 5px !important;
    font-size: 0.62rem !important;
    line-height: 1;
    border-radius: 5px;
    flex: 1 1 0;
    min-width: 0;
    overflow: hidden;
    text-overflow: ellipsis;
  }

  @media (max-width: 380px) {
    height: 26px;
    min-height: 26px;
    padding: 0 4px !important;
    font-size: 0.56rem !important;
  }
`;

const StyledInput = styled.input`
  width: 100%;
  padding: 14px 18px;
  margin-bottom: 24px;
  font-size: 16px;
  border: 1px solid ${(props) => (props.invalid ? "#dc3545" : "#ddd")};
  border-radius: 10px;
  background-color: #fafafa;
  transition: all 0.2s ease;

  &:focus {
    border-color: ${(props) => (props.invalid ? "#dc3545" : "#de8c3a")};
    background-color: #fff;
    box-shadow: ${(props) =>
      props.invalid
        ? "0 0 0 4px rgba(220, 53, 69, 0.15)"
        : "0 0 0 4px rgba(222, 140, 58, 0.15)"};
    outline: none;
  }

  &::placeholder {
    color: #aaa;
  }
`;

function RestaurantInfo() {
  const restaurantList = useSelector((state) => state.restaurantList);
  const { restaurants, isLoading, error } = restaurantList;

  const [showModal, setShowModal] = useState(false);
  const [restaurantName, setRestaurantName] = useState(false);
  const [restaurantIdToDelete, setRestaurantIdToDelete] = useState(null);
  const [enteredName, setEnteredName] = useState("");
  const [errorMessage, setErrorMessage] = useState(false);
  const userLogin = useSelector((state) => state.userLogin);
  const { userInfo } = userLogin;
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const crudManagerPermissions = useSelector((state) => state.crudManager);
  const { managerInfo } = crudManagerPermissions;

  useEffect(() => {
    dispatch(fetchReservationDeactivate());
    //dispatch(resetRestaurantDetailsNow());
    if (managerInfo) {
      if (managerInfo.first_time_password_change === false) {
        navigate(`/profile/update/${"first_time"}`);
      }
    }
  }, [managerInfo]);

  useEffect(() => {
    dispatch(resetConfirmSubscription());
  }, []);

  const handleRestaurantDetails = (restaurantId) => {
    dispatch(fetchRestaurantDetails(restaurantId));
    navigate(`/restaurant_info_update/${restaurantId}`);
  };

  const handleReservationFromRestaurant = (restaurantId) => {
    dispatch(fetchRestaurantDetails(restaurantId));
    navigate(`/reservationfromrestaurant/${restaurantId}/null/all`);
  };

  const handleRestaurantSubscriptions = (restaurantId) => {
    dispatch(fetchRestaurantDetails(restaurantId));
    navigate(`/subscription_management/${restaurantId}`);
  };

  const handleChoosePlanAndPay = (restaurantId) => {
    dispatch(fetchRestaurantDetails(restaurantId));
    navigate(`/pick_plan_and_pay/${restaurantId}`);
  };

  const handleDelete = (restaurantId, restaurant_name) => {
    setRestaurantIdToDelete(restaurantId);
    setShowModal(true);
    setRestaurantName(restaurant_name);
    setEnteredName("");
    setErrorMessage(false);
  };

  const confirmDelete = () => {
    if (enteredName === restaurantName) {
      dispatch(destroyItems(restaurantIdToDelete, "restaurants"));
      setShowModal(false);
    } else {
      setErrorMessage(true);
    }
  };

  const closeModal = () => {
    setShowModal(false);
  };

  /*   useEffect(() => {
    if (error === "Given token not valid for any token type") {
      dispatch(logout());
    } else if (error) {
      window.location.reload();
    }
  }, [error]); */

  return (
    <Container>
      <ToastContainer />
      <RestaurantsHeader />

      {isLoading ? (
        <Loader />
      ) : error ? (
        <Messages variant="danger">{error}</Messages>
      ) : restaurants && Object.keys(restaurants).length > 0 ? (
        <>
          {restaurants.map((restaurant) => (
            <StyledCard key={restaurant.id}>
              <StyledCardTop>
                <div
                  style={{
                    display: "flex",
                    alignItems: "center",
                    gap: "8px",
                    color: "#FAF6E9",
                    minWidth: 0,
                  }}
                >
                  <FontAwesomeIcon
                    icon={faUtensils}
                    style={{ color: "#FAF6E9", flex: "0 0 auto" }}
                  />
                  <span
                    style={{
                      overflow: "hidden",
                      textOverflow: "ellipsis",
                      whiteSpace: "nowrap",
                    }}
                  >
                    {restaurant.restaurant_name}
                  </span>
                </div>

                <div
                  style={{
                    display: "flex",
                    alignItems: "center",
                    gap: "10px",
                    flex: "0 0 auto",
                  }}
                >
                  {!managerInfo && (
                    <FontAwesomeIcon
                      onClick={() => handleRestaurantDetails(restaurant.id)}
                      icon={faPen}
                      style={{
                        fontSize: "19px",
                        color: "#FAF6E9",
                        cursor: "pointer",
                      }}
                    />
                  )}

                  {!managerInfo && (
                    <div
                      onClick={() =>
                        handleDelete(restaurant.id, restaurant.restaurant_name)
                      }
                      style={{
                        cursor: "pointer",
                        fontSize: "20px",
                        color: "#FAF6E9",
                      }}
                    >
                      <FontAwesomeIcon
                        icon={faTrash}
                        style={{ fontSize: "20px", color: "#FAF6E9" }}
                      />
                    </div>
                  )}
                </div>
              </StyledCardTop>

              <StyledCardBot>
                <Row>
                  <Col xs={12} md={6}>
                    <Card.Text>{restaurant.adress}</Card.Text>
                  </Col>

                  <ButtonsCol xs={12} md={12}>
                    {restaurant.subscription_status !== "active" &&
                    restaurant.subscription_status !== "trialling" &&
                    restaurant.subscription_status !== "trialing" ? (
                      <ActionButtons>
                        <CompactModernButton
                          color={"#99b0ad "}
                          style={{ fontSize: "0.8rem" }}
                          onClick={() => handleChoosePlanAndPay(restaurant.id)}
                        >
                          Gerir plano
                        </CompactModernButton>
                      </ActionButtons>
                    ) : (
                      <ActionButtons>
                        <CompactModernButton
                          color={"#FAF6E9"}
                          style={{ color: "#EE754C" }}
                          onClick={() =>
                            handleReservationFromRestaurant(restaurant.id)
                          }
                        >
                          Reservas{" "}
                          <FontAwesomeIcon
                            size="sm"
                            icon={faArrowRightToBracket}
                            style={{ color: "#EE754C", marginLeft: "3px" }}
                          />
                        </CompactModernButton>

                        <CompactModernButton
                          color={"#99B0AD"}
                          onClick={() =>
                            navigate(`/restaurant_widget/${restaurant.id}`)
                          }
                        >
                          Widget
                        </CompactModernButton>

                        <CompactModernButton
                          color={"#EE754C"}
                          onClick={() =>
                            navigate(
                              `/reservations/${restaurant.id}/client/no_id`,
                            )
                          }
                        >
                          Nova reserva
                        </CompactModernButton>

                        <CompactModernButton
                          color={"#99b0ad "}
                          onClick={() =>
                            handleRestaurantSubscriptions(restaurant.id)
                          }
                        >
                          Gerir plano
                        </CompactModernButton>

                        <CopyToClipboard
                          text={`http://www.soup.red/#/reservations/${restaurant.id}/client/no_id`}
                          onCopy={() =>
                            toast(
                              "Link copiado! Já podes partilhá-lo ou inserí-lo no site do restaurante.",
                              { autoClose: 1000 },
                            )
                          }
                        >
                          <CompactModernButton
                            color={"#FAF6E9"}
                            style={{
                              color: "#EE754C",
                              flex: "0 0 30px",
                              maxWidth: "30px",
                              paddingLeft: "0",
                              paddingRight: "0",
                            }}
                          >
                            <FiCopy />
                          </CompactModernButton>
                        </CopyToClipboard>
                      </ActionButtons>
                    )}
                  </ButtonsCol>
                </Row>
              </StyledCardBot>
            </StyledCard>
          ))}
        </>
      ) : (
        <></>
      )}

      <ConfirmationModal
        show={showModal}
        onHide={closeModal}
        onConfirm={confirmDelete}
        title="Apagar restaurante"
        body={
          <>
            <p>Tem a certeza que pretende apagar este restaurante?</p>
            <p>
              ATENÇÃO: se apagar o restaurante irá apagar toda a informação do
              mesmo {"(reservas, clientes, informação, definições, etc.)"}!
            </p>
            <Form.Group
              controlId="restaurantNameInput"
              style={{ marginTop: "15px" }}
            >
              <Form.Label>
                Escreva <strong>"{restaurantName}"</strong> para continuar.
              </Form.Label>
              <StyledInput
                type="text"
                placeholder="Nome do restaurante"
                value={enteredName}
                onChange={(e) => {
                  setEnteredName(e.target.value);
                  if (errorMessage) setErrorMessage(false);
                }}
                invalid={!!errorMessage}
              />
              {/*
              {errorMessage && (
                <p style={{ color: "red", marginTop: "5px" }}>Nome errado*</p>
              )}
                */}
            </Form.Group>
          </>
        }
        confirmLabel="Apagar"
        cancelLabel="Cancelar"
        confirmColor="#ee754c"
        cancelColor="#99b0ad"
      />
    </Container>
  );
}

export default RestaurantInfo;
